import React, { useState, useEffect } from "react";
import { NumericFormat } from "react-number-format";
import { useHistory } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { Formik } from "formik";
import * as Yup from 'yup';
import axios from "axios";
import _, { parseInt } from "lodash";
import moment from "moment";

// Components
import { errorSwal, successSwal } from "../../../helper/sweetalert";
import { COLOR_WHITE, LINEAR_GRADIENT_BG, USER_KEY } from "../../../const";
import BreadCrumbComponent from "../../../components/BreadCrumbComponent";
import useWindowDimensions from "../../../helper/windowDimensions";
import { ReactIcons } from "../../../icons";

// Apollo GraphQL
import { useLazyQuery, useMutation } from "@apollo/client";
import { GET_PRODUCT_GENBARCODE } from "../../../apollo/product/query";
import { GET_PRESIGN_URL } from "../../../apollo/presignUrl/query";
import { CREATE_MANAGEMENT_PRODUCTS, CREATE_PRODUCT } from "../../../apollo/product/Mutation";
import { GET_CATEGORYS } from "../../../apollo/category/query";
import { GET_SUBBRANDS } from "../../../apollo/subbrand/query";
import { GET_BRANDS } from "../../../apollo/brand/Query";
import { GET_SUVIVALS, GET_UNITS } from "../../../apollo/unit/Query";

// Icons
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import ClearIcon from "@mui/icons-material/Clear";
import AddIcon from "@mui/icons-material/Add";

// UI Components
import { Col, Form, InputGroup, Row, Button } from "react-bootstrap";

// Validation schema for product form
const ProductValidationSchema = Yup.object().shape({
  name: Yup.string().required('ກະລຸນາປ້ອນຊື່ສິນຄ້າ!'),
  amount: Yup.string().required('ກະລຸນາປ້ອນຈຳນວນກ່ອນ!'),
  currency: Yup.string().required('ກະລຸນາເລືອກສະກຸນເງິນ'),
  sku: Yup.string().required('ກະລຸນາປ້ອນລະຫັດ SKU!'),
  //survivalNumber: Yup.string().required('ກະລຸນາເລືອກໝາຍເລກລອດ!'),
});

// Initial form values
const initialFormValues = {
  name: "",
  priceOptions: [{}],
  amount: "",
  originPrice: "",
  promoPrice: "",
  isPromo: false,
  cfMessage: "",
  currency: "",
  shortDescription: "",
  description: "",
  detail: "",
  size: "",
  barCode: "",
  brand: "",
  category: "",
  image: "",
  creationDate: "",
  expirationDate: "",
  shippingCost: 0,
  sku: "",
  isUsingSalePage: false,
  priceDisplay: "",
  specifications: [{ key: "", value: "" }],
};

// Initial dimension values
const initialDimensionValues = {
  length: '',
  width: '',
  height: '',
  weight: ''
};

function AddOneProductManagement(props) {
  const shopId = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
  const historyRouter = useHistory();
  const specificationKeys = [
    { key: "", label: "-----ເລືອກຄຸນລັກສະນະ-----" },
    { key: "Color", label: "ສີ" },
    { key: "Size", label: "ຂະໜາດ" },
    { key: "Material", label: "ວັດຖຸດິບ" },
    { key: "Weight", label: "ນ້ຳໜັກ" },
    { key: "Length", label: "ຄວາມຍາວ" },
    { key: "Width", label: "ຄວາມກ້ວາງ" },
    { key: "Height", label: "ຄວາມສູງ" },
    { key: "Origin", label: "ຕົ້ນກຳເນີດ" },
    { key: "Made_in", label: "ຜະລິດໃນ" },
    { key: "Brand", label: "ແບຣນ" },
    { key: "Model", label: "ຮຸ່ນ" },
    { key: "Warranty", label: "ຮັບປະກັນ" },
    { key: "Battery", label: "ແບັດເຕີຣີ" },
    { key: "Voltage", label: "ແຮງດັນ" },
    { key: "Power", label: "ກຳລັງໄຟ" },
    { key: "Capacity", label: "ຄວາມຈຸ" },
    { key: "Volume", label: "ປະລິມານ" },
    { key: "Package", label: "ໃນກ່ອງ" },
    { key: "Pattern", label: "ລາຍ" },
    { key: "Gender", label: "ເພດ" },
    { key: "Age", label: "ອາຍຸ" },
    { key: "Fabric", label: "ເນື້ອຜ້າ" },
    { key: "Fit", label: "ຮູບຊົງ" },
    { key: "Style", label: "ສະໄຕລ໌" },
    { key: "Usage", label: "ການນຳໃຊ້" },
    { key: "Storage", label: "ການເກັບຮັກສາ" },
    { key: "Shelf_Life", label: "ອາຍຸການເກັບ" },
  ];
  
  // State for dropdown data
  const [category, setCategory] = useState([]);
  const [brand, setBrand] = useState([]);
  const [subBrand, setSubBrand] = useState([]);
  const [unit, setUnit] = useState([]);
  const [survivalDatas, setSurvivalDatas] = useState([]);
  
  // Form state
  const [history, setHistory] = useState([]);
  const [isChecked, setIsChecked] = useState(true);
  const [isCheckSku, setIsCheckSku] = useState(true);
  const [hasVariant, setHasVariant] = useState(false);
  const [searchBrand, setSearchBrand] = useState("");
  const [searchCategory, setSearchCategory] = useState("");
  const [searchSubbrand, setSearchSubbrand] = useState("");
  const [sortNumber, setSortNumber] = useState(0);
  const [selecteUnit, setSelectedUnit] = useState("");
  const [selectSurvivalNumber, setSelectSurvivalNumber] = useState("");
  const [priceOptions, setPriceOptions] = useState([
    { price: 0, contain: "1", unit: "" },
  ]);
  
  // Barcode state
  const [genBarCode, setGenBarCode] = useState("");
  const [barcode, setBarCode] = useState("");
  const [sku, setSku] = useState("");
  
  // Image upload state
  const [files, setFiles] = useState([]);
  const [imageLoading, setImageLoading] = useState(0);
  const [fileNames, setFileNames] = useState([]);
  const [previewImages, setPreviewImages] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  
  // Form values
  const [copyData, setCopyData] = useState(initialFormValues);
  const [formDimension, setFormDimension] = useState(initialDimensionValues);
  
  // Window dimensions
  const { width } = useWindowDimensions();

  // GraphQL queries and mutations
  const [getCategory, { data: GetCategoryData, loading: loadingCategory }] = 
    useLazyQuery(GET_CATEGORYS, { fetchPolicy: "network-only" });
    
  const [getBrand, { data: GetBrandData, loading: loadingBrand }] = 
    useLazyQuery(GET_BRANDS, { fetchPolicy: "network-only" });
    
  const [loadSubBrand, { data: GetSubBrandData, loading: loadingSubBrand }] = 
    useLazyQuery(GET_SUBBRANDS, { fetchPolicy: "network-only" });
    
  const [getUnit, { data: GetUnitData, loading: loadingUnit }] = 
    useLazyQuery(GET_UNITS, { fetchPolicy: "network-only" });
    
  const [loadGenBarCode, { data: GetGenBarCodeData, loading: loadingGenBarCode }] = 
    useLazyQuery(GET_PRODUCT_GENBARCODE, { fetchPolicy: "network-only" });
    
  const [getSurvivalData, { loading: loadingSurvival, data: survivalDatasLoad, error: survivalError }] = 
    useLazyQuery(GET_SUVIVALS, { fetchPolicy: "cache-and-network" });
    
  const [getPresignUrl, { data: presignUrlData }] = 
    useLazyQuery(GET_PRESIGN_URL);
    
  const [createProduct, { loading: loadingCreate }] = 
    useMutation(CREATE_PRODUCT);
  const [createManagementProduct, { loading: createManagementProductLoading }] = useMutation(CREATE_MANAGEMENT_PRODUCTS);
  
  /**
   * Reset form to initial state
   */
  const handleClearForm = () => {
    setCopyData(initialFormValues);
    setFormDimension(initialDimensionValues);
    setFiles([]);
    setFileNames([]);
    setPreviewImages([]);
    setPriceOptions([{ price: 0, contain: "1", unit: "" }]);
    loadBarCode();
    generateSku(); // Generate a new SKU when form is cleared
  }

  // Initial data loading on component mount
  useEffect(() => {
    fetchUnits();
    loadBarCode();
    fetchCategories();
    loadShopData();
  }, []);

  // Data processing effects
  useEffect(() => {
    if (GetCategoryData) {
      setCategory(GetCategoryData?.categories?.data || []);
    }
  }, [GetCategoryData]);

  useEffect(() => {
    if (GetBrandData) {
      setBrand(GetBrandData?.brands?.data || []);
    }
  }, [GetBrandData]);

  useEffect(() => {
    if (GetSubBrandData) {
      const result = [...(GetSubBrandData?.subBrands?.data || [])].sort((a, b) =>
        a?.name?.localeCompare(b?.name)
      );
      setSubBrand(result);
    }
  }, [GetSubBrandData]);

  useEffect(() => {
    if (GetUnitData) {
      setUnit(GetUnitData?.units?.data || []);
    }
  }, [GetUnitData]);

  // Generate barcode from product total
  useEffect(() => {
    if (GetGenBarCodeData) {
      const number = GetGenBarCodeData?.products?.total + 1;
      let formattedBarcode = number.toString();
      
      if (number <= 9) formattedBarcode = "00000" + formattedBarcode;
      else if (number <= 99) formattedBarcode = "0000" + formattedBarcode;
      else if (number <= 999) formattedBarcode = "000" + formattedBarcode;
      else if (number <= 9999) formattedBarcode = "00" + formattedBarcode;
      
      setGenBarCode(formattedBarcode);
    }
  }, [GetGenBarCodeData]);

  // Handle image upload
  useEffect(() => {
    if (presignUrlData?.preSignedUrl?.url) {
      uploadFileToUrl(presignUrlData?.preSignedUrl?.url);
    }
  }, [presignUrlData]);

  // Filter data when search parameters change
  useEffect(() => {
    updateFilters();
    fetchBrands();
    fetchSubBrands();
  }, [searchBrand, searchCategory, searchSubbrand]);

  // Process survival data when it loads
  useEffect(() => {
    if (survivalDatasLoad) {
      setSurvivalDatas(survivalDatasLoad?.survivals?.data || []);
    }
  }, [survivalDatasLoad]);
  
  // Generate SKU on component mount
  useEffect(() => {
    if (isCheckSku) {
      const newSku = generateSku();
      setCopyData(prev => ({
        ...prev,
        sku: newSku
      }));
    }
  }, []);
  
  /**
   * Load shop data and fetch survival data
   */
  const loadShopData = () => {
    const userData = localStorage.getItem("SHOP_DATA");
    if (userData) {
      const locals = JSON.parse(userData);
      if (locals && locals.id) {
        fetchSurvivalDatas(locals.id);
      }
    }
  };

  /**
   * Fetch survival data for a specific shop
   * @param {string} shopId - The shop ID to fetch survival data for
   */
  const fetchSurvivalDatas = async (shopId) => {
    if (loadingSurvival) return; // Prevent re-triggering if already loading

    try {
      await getSurvivalData({
        variables: {
          where: {
            shop: shopId,
            status: true,
            isDeleted: false
          }
        }
      });
    } catch (err) {
      console.error("Failed to load survival data:", err);
    }
  };

  /**
   * Fetch brands filtered by category if selected
   */
  const fetchBrands = () => {
    const whereClause = {
      shop: shopId,
      isDeleted: false
    };
    
    if (searchCategory) {
      whereClause.category = searchCategory;
    }

    getBrand({
      variables: {
        limit: 1000,
        where: whereClause
      }
    });
  };

  /**
   * Fetch sub-brands filtered by brand if selected
   */
  const fetchSubBrands = () => {
    const whereClause = {
      shop: shopId,
      isDeleted: false
    };
    
    if (searchBrand) {
      whereClause.brand = searchBrand;
    }

    loadSubBrand({
      variables: {
        limit: 1000,
        where: whereClause
      }
    });
  };

  /**
   * Update filters based on selected category, brand, and sub-brand
   */
  const updateFilters = async () => {
    try {
      const shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
      if (!shopId) return;

      // This function prepares filter conditions for potential product filtering
      // Currently used to prepare for other filter functions
    } catch (error) {
      console.error("Error updating filters:", error);
    }
  };

  /**
   * Load barcode generation data
   */
  const loadBarCode = async () => {
    try {
      const shopId = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
      if (!shopId) return;

      await loadGenBarCode({
        variables: {
          where: {
            shop: shopId
          }
        }
      });
    } catch (error) {
      console.error("Error loading barcode:", error);
    }
  };

  /**
   * Fetch unit data
   */
  const fetchUnits = async () => {
    try {
      const shopId = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
      if (!shopId) return;
      
      await getUnit({
        variables: {
          where: {
            isDeleted: false,
            shop: shopId
          }
        }
      });
    } catch (error) {
      console.error("Error fetching units:", error);
    }
  };
  
  /**
   * Fetch categories
   */
  const fetchCategories = async () => {
    try {
      await getCategory({
        variables: {
          limit: 1000,
          where: {
            shop: shopId,
            isDeleted: false
          }
        }
      });
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  /**
   * Image thumbnail component
   * @param {Object} props - Component props
   * @param {File} props.image - Image file to display
   */
  const ImageThumb = ({ image }) => {
    return (
      <img
        src={URL.createObjectURL(image)}
        alt={image.name}
        style={{
          objectFit: "contain",
          borderRadius: 8,
          height: 150,
          width: 150,
          margin: 5
        }}
      />
    );
  };

  /**
   * Remove an image from the selection
   * @param {number} index - Index of image to remove
   */
  const handleRemoveFile = (index) => {
    setFiles(prevFiles => prevFiles.filter((_, i) => i !== index));
    setPreviewImages(prevPreviews => prevPreviews.filter((_, i) => i !== index));
  };

  /**
   * Set an image as the cover photo (moves it to the first index)
   * @param {number} index - Index of image to set as cover
   */
  const handleSetCover = (index) => {
    if (index === 0) return;

    setFiles(prev => {
      const newFiles = [...prev];
      const selected = newFiles.splice(index, 1)[0];
      newFiles.unshift(selected);
      return newFiles;
    });

    setPreviewImages(prev => {
      const newPreviews = [...prev];
      const selected = newPreviews.splice(index, 1)[0];
      newPreviews.unshift(selected);
      return newPreviews;
    });
  };

  /**
   * Handle file selection from input
   * @param {Event} event - File input change event
   */
  const handleUpload = (event) => {
    try {
      const uploadedFiles = Array.from(event.target.files);
      if (!uploadedFiles.length) return;
      
      // Add new files to existing files array
      setFiles(prevFiles => [...prevFiles, ...uploadedFiles]);
      
      // Create preview images for display
      setPreviewImages(prevPreviews => [
        ...prevPreviews,
        ...uploadedFiles.map(file => ({
          file,
          preview: URL.createObjectURL(file)
        }))
      ]);
    } catch (error) {
      console.error("Error handling file selection:", error);
      errorSwal("ເກີດຂໍ້ຜິດພາດໃນການເລືອກຮູບພາບ");
    }
  };

  /**
   * Upload file to presigned URL
   * @param {File} file - File to upload
   * @param {string} url - Presigned URL for upload
   * @returns {Promise<boolean>} - Whether the upload was successful
   */
  const uploadFileToUrl = async (file, url) => {
    try {

      // Upload with correct Content-Type header
      if(url && file){
        await axios.put(url, file, {
          headers: {
            "Content-Type": "file/*; image/*",
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
          },
        });
        
      }

      return true;
    } catch (error) {
      console.error("Error uploading file:", error.message);
      if (error.response) {
        console.error("Response status:", error.response.status);
        console.error("Response data:", error.response.data);
      }
      return false;
    }
  };
  
  /**
   * Upload all selected files to the server
   * @returns {Promise<string[]>} - Array of uploaded file names
   */
  const uploadAllFiles = async () => {
    if (files.length === 0) return [];
    
    setIsUploading(true);
    setImageLoading(0);
    
    try {
      // Array to store uploaded filenames
      const uploadedFiles = [];
      
      // Process each file
      for (let i = 0; i < files.length; i++) {
        // Update progress
        setImageLoading(Math.round(((i) / files.length) * 100));
        
        const file = files[i];
        const fileExt = file.name.split('.').pop().toLowerCase();
        const filename = `product_${Date.now()}_${i}.${fileExt}`;
        
        // Get presigned URL
        const result = await getPresignUrl({
          variables: { name: filename }
        });
        const url = result?.data?.preSignedUrl?.url;
        if (!url) {
          console.error("Failed to get presigned URL for", filename);
          continue;
        }
  
        // Upload file
        const success = await uploadFileToUrl(file, url);
        if (success) {
          uploadedFiles.push(filename);
        }
        
        // Update progress
        setImageLoading(Math.round(((i + 1) / files.length) * 100));
      }
      
      // Update state with uploaded filenames
      setFileNames(uploadedFiles);
      return uploadedFiles;
    } catch (error) {
      console.error("Error uploading files:", error);
      errorSwal("ເກີດຂໍ້ຜິດພາດໃນການອັບໂຫລດຮູບພາບ");
      return [];
    } finally {
      setIsUploading(false);
    }
  };
  
  /**
   * Parse numeric string to float, handling commas
   * @param {string} value - Numeric string to parse
   * @returns {number} - Parsed float value or 0 if invalid
   */
  const parseNumericValue = (value) => {
    if (!value) return 0;
    return parseFloat(value.toString().replace(/,/g, ""));
  };

  const normalizeObjectIdValue = (value) => {
    if (value === null || value === undefined) return undefined;
    if (typeof value !== "string") return value;
    const trimmed = value.trim();
    if (!trimmed || trimmed === "--ເລືອກ--" || trimmed === "ALL") return undefined;
    return trimmed;
  };
  
  /**
   * Create product with form values
   * @param {Object} values - Form values from Formik
   */
  const handleCreateProductNew = async (values) => {
    try {
      if (createManagementProductLoading || isUploading) return;
      
      // Validate required fields
      if (!values?.name) {
        return errorSwal("ກະລຸນາປ້ອນຊື່ສິນຄ້າ!");
      }
      
      if (hasVariant) {
        // Validate variant product fields
        if (!searchCategory) {
          return errorSwal("ກະລຸນາເລືອກປະເພດ!");
        }
      } else {
        // Validate normal product fields
        if (!values?.amount) {
          return errorSwal("ກະລຸນາປ້ອນຈຳນວນ!");
        }
        if (!values?.currency) {
          return errorSwal("ກະລຸນາເລືອກສະກຸນເງິນ!");
        }
        if (priceOptions[0]?.price <= 0) {
          return errorSwal("ກະລຸນາປ້ອນລາຄາຂາຍ!");
        }
      }
      
      const survivalId = normalizeObjectIdValue(selectSurvivalNumber);
      const unitId = normalizeObjectIdValue(selecteUnit);
      const specifications = (values?.specifications || [])
        .map((item) => ({
          key: (item?.key ?? "").trim(),
          value: (item?.value ?? "").trim(),
        }))
        .filter((item) => item.key || item.value);
      
      const shopId = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
      if (!shopId) {
        return errorSwal("ບໍ່ພົບຂໍ້ມູນຮ້ານຄ້າ");
      }
      
      // First upload all images and get their filenames
      const uploadedFileNames = await uploadAllFiles();
      
      // Prepare product data based on hasVariant
      let productData;
      
      if (hasVariant) {
        // For variant product, only send basic info
        productData = {
          name: values?.name,
          category: normalizeObjectIdValue(searchCategory),
          brand: normalizeObjectIdValue(searchBrand),
          cfMessage: values?.cfMessage,
          shortDescription: values?.shortDescription,
          description: values?.description,
          shop: shopId,
          hasVariant: true,
          priceDisplay: values?.priceDisplay,
          platform: "POS",
          type: "KEY_IN",
          image: uploadedFileNames || [],
          isUsingSalePage: values?.isUsingSalePage,
          ...(survivalId ? { survivalId } : {})
        };
        if (specifications.length > 0) {
          productData.specifications = specifications;
        }
        // Add optional fields only if they have values
        if (barcode || values?.barCode) {
          productData.barCode = barcode || values?.barCode;
        }
        if (values?.sku) {
          productData.sku = values.sku;
        }
      } else {
        // For normal product, send all data
        productData = {
          ...values,
          priceOptions,
          barCode: isChecked ? genBarCode : barcode,
          sku: isCheckSku ? sku : values.sku,
          category: normalizeObjectIdValue(searchCategory),
          brand: normalizeObjectIdValue(searchBrand),
          subbrand: normalizeObjectIdValue(searchSubbrand),
          ...(unitId ? { unitId } : {}),
          ...(survivalId ? { survivalId } : {}),
          sort: parseInt(sortNumber),
          amount: parseNumericValue(values.amount),
          originPrice: parseNumericValue(values.originPrice),
          promoPrice: parseNumericValue(values.promoPrice),
          isPromo: values.isPromo || false,
          price: priceOptions.length > 0 ? priceOptions[0].price : 0,
          shop: shopId,
          dimension: {
            length: parseNumericValue(formDimension.length),
            width: parseNumericValue(formDimension.width),
            height: parseNumericValue(formDimension.height),
            weight: parseNumericValue(formDimension.weight)
          },
          shippingCost: parseNumericValue(values.shippingCost),
          platform: "POS",
          type: "KEY_IN",
          image: uploadedFileNames || []
        };
        if (specifications.length > 0) {
          productData.specifications = specifications;
        }
      }
      
      // Create product
      const result = await createManagementProduct({
        variables: {
          data: [productData],
          where: survivalId ? { lot: survivalId } : {}
        },
      });
      const {status, msg} = result.data?.createManagementProduct;
      if (!status) {
        return errorSwal(msg);
      }

      // Update history
      const historyShowData = [
        ...history,
        { ...values, priceOptions, images: previewImages }
      ];
      setHistory(historyShowData);

      successSwal("ເພິ່ມສິນຄ້າສຳເລັດແລ້ວ");
      handleClearForm();
    } catch (err) {
      if (err.message === "PRODUCT_ALREADY_EXIST") {
        return errorSwal("ລາຍການສິນຄ້ານີ້ມີຢູ່ແລ້ວ");
      }
      console.error("Error creating product:", err);
      errorSwal("ເກີດຂໍ້ຜິດພາດກະລຸນາລອງໃຫມ່ອີກຄັ້ງ");
    }
  };

  /**
   * Add a new price option to the list
   */
  const handleAddMorePrice = () => {
    setPriceOptions([...priceOptions, { price: 0, contain: "", unit: "" }]);
  };

  /**
   * Update a price value in price options
   * @param {string} value - New price value
   * @param {number} index - Index of price option to update
   */
  const handlePriceChange = (value, index) => {
    const updatedOptions = [...priceOptions];
    updatedOptions[index] = {
      ...updatedOptions[index],
      price: parseFloat(value.toString().replace(/,/g, "")) || 0
    };
    setPriceOptions(updatedOptions);
  };

  /**
   * Update a contain value in price options
   * @param {string} value - New contain value
   * @param {number} index - Index of price option to update
   */
  const handleContainChange = (value, index) => {
    const updatedOptions = [...priceOptions];
    updatedOptions[index] = {
      ...updatedOptions[index],
      contain: value.toString()
    };
    setPriceOptions(updatedOptions);
  };

  /**
   * Update a unit value in price options
   * @param {string} value - New unit value
   * @param {number} index - Index of price option to update
   */
  const handleUnitChange = (value, index) => {
    const updatedOptions = [...priceOptions];
    updatedOptions[index] = {
      ...updatedOptions[index],
      unit: value.toString()
    };
    setPriceOptions(updatedOptions);
  };

  /**
   * Delete a price option
   * @param {number} index - Index of price option to delete
   */
  const handleDeletePriceOption = (index) => {
    const updatedOptions = [...priceOptions];
    updatedOptions.splice(index, 1);
    setPriceOptions(updatedOptions);
  };

  /**
   * Copy data from history to form
   * @param {Object} historyItem - History item to copy
   */
  const handleCopyFromHistory = (historyItem) => {
    setCopyData(historyItem);
    setPriceOptions(historyItem.priceOptions || [{ price: 0, contain: "1", unit: "" }]);
  };

  /**
   * Toggle auto barcode generation
   * @param {Event} event - Checkbox change event
   */
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  /**
   * Handle variant product mode toggle
   * @param {Event} event - Switch change event
   */
  const handleVariantChange = (event) => {
    const isVariant = event.target.checked;
    setHasVariant(isVariant);
    
    if (isVariant) {
      // Clear generated barcode and SKU when variant is enabled
      setGenBarCode("");
      setSku("");
      setBarCode("");
      setCopyData(prev => ({
        ...prev,
        sku: ''
      }));
    }
  };

  /**
   * Generate a unique SKU based on current timestamp
   * @returns {string} - Generated SKU
   */
  const generateSku = () => {
    const prefix = "SKU";
    const dateString = moment().format('YYMMDDHHmmss');
    const randomDigits = Math.floor(Math.random() * 1000).toString().padStart(3, '0');
    const newSku = `${prefix}${dateString}${randomDigits}`;
    setSku(newSku);
    return newSku;
  };

  /**
   * Toggle auto SKU generation
   * @param {Event} event - Checkbox change event
   */
  const handleCheckboxChangeSku = (event) => {
    const isChecked = event.target.checked;
    setIsCheckSku(isChecked);
    
    if (isChecked) {
      // Generate a new SKU and update form values
      const newSku = generateSku();
      setCopyData(prev => ({
        ...prev,
        sku: newSku
      }));
    } else {
      // Clear SKU when auto is disabled
      setCopyData(prev => ({
        ...prev,
        sku: ''
      }));
    }
  };

  /**
   * Update manual barcode value
   * @param {Event} event - Input change event
   */
  const handleBarcodeChange = (event) => {
    setBarCode(event.target.value);
  };

  /**
   * Update dimension values
   * @param {Event} e - Input change event
   */
  const handleChangeDimension = (e) => {
    const { name, value } = e.target;
    // Allow numbers with up to 2 decimal places and total length of 7 (4 digits + decimal point + 2 decimal places)
    if (value === '' || /^\d{0,4}(\.\d{0,2})?$/.test(value)) {
      setFormDimension(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  return (
    <>
      <BreadCrumbComponent
        goback={() => historyRouter.goBack()}
        txtFirst="ສາງສິນຄ້າ"
        txtSecond={`ເພິ່ມສິນຄ້າສຳລັບການຈັດການສີນຄ້າເຂົ້າອອກ`}
      />

      <Formik
        enableReinitialize={true}
        initialValues={copyData}
        validationSchema={hasVariant ? Yup.object().shape({
          name: Yup.string().required('ກະລຸນາປ້ອນຊື່ສິນຄ້າ!')
        }) : ProductValidationSchema}
        validate={(values) => {
          const errors = {};
          
          // Validation based on hasVariant
          if (!hasVariant) {
            // For normal products, validate price
            if (priceOptions[0]?.price <= 0) {
              errors.priceOptions = "ກະລຸນາປ້ອນລາຄາຂາຍ!";
            }
          }
          // Variant products validation is handled in handleCreateProductNew
          return errors;
        }}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          handleCreateProductNew(values);
        }}>
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          setFieldValue,
          handleSubmit,
        }) => (
          <div style={{ display: "flex", justifyContent: 'start', alignItems: 'start', flexDirection: width > 700 ? "row" : "column", padding: 20 }}>

            {/* upload image element  */}
            <div
              style={{
                width: width > 700 ? "35%" : '100%',
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "start",
                padding: 10
              }}>
              <div style={{ textAlign: "center", width: "100%" }}>
                <input
                  type="file"
                  id="file-upload"
                  onChange={handleUpload}
                  multiple
                  hidden
                />
                <label htmlFor="file-upload">
                  <div
                    style={{
                      backgroundColor: "#F9FAFB",
                      height: "100%",
                      width: "100%",
                      border: "1px dashed #93989F",
                      borderRadius: 8,
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                      padding: 10
                    }}>
                    {files.length === 0 ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          height: 300,
                          width: 300,
                          justifyContent: "center",
                          alignItems: "center",
                        }}>
                        <CloudUploadOutlinedIcon
                          sx={{ fontSize: 50, color: "#93989F" }}
                        />
                        <p style={{ color: "#93989F" }}>ເພີ່ມຮູບສິນຄ້າ (ເລືອກໄດ້ຫຼາຍຮູບ)</p>
                        <p
                          style={{
                            color: "#3C169B",
                            textDecoration: "underline",
                          }}>
                          Browse
                        </p>
                      </div>
                    ) : (
                      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                        {/* Image upload progress indicator */}
                        {isUploading && (
                          <div style={{ marginBottom: 10, width: "100%" }}>
                            <p>Uploading images: {imageLoading}%</p>
                            <div style={{ 
                              width: "100%", 
                              height: 5, 
                              backgroundColor: "#f0f0f0",
                              borderRadius: 3,
                              overflow: "hidden"
                            }}>
                              <div style={{ 
                                width: `${imageLoading}%`, 
                                height: "100%", 
                                backgroundColor: "#3C169B",
                                transition: "width 0.3s ease"
                              }} />
                            </div>
                          </div>
                        )}
                        
                        {/* Image previews */}
                        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 10 }}>
                          {files.map((file, index) => (
                            <div 
                              key={index} 
                              style={{ 
                                position: "relative",
                                width: 150,
                                height: 150,
                                border: index === 0 ? "2px solid #3C169B" : "1px solid #E5E7EB",
                                borderRadius: 8,
                                overflow: "hidden",
                                cursor: index === 0 ? "default" : "pointer",
                              }}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleSetCover(index);
                              }}
                            >
                              <ImageThumb image={file} />
                              {index === 0 ? (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    background: "#3C169B",
                                    color: "#fff",
                                    padding: "2px 6px",
                                    fontSize: 10,
                                    borderBottomRightRadius: 8,
                                    zIndex: 1,
                                  }}
                                >
                                  ພາບໜ້າປົກ
                                </div>
                              ) : (
                                <div
                                  style={{
                                    position: "absolute",
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    background: "rgba(0,0,0,0.5)",
                                    color: "#fff",
                                    fontSize: 10,
                                    textAlign: "center",
                                    padding: "2px 0",
                                  }}
                                >
                                  ຕັ້ງເປັນພາບໜ້າປົກ
                                </div>
                              )}
                              <div 
                                style={{
                                  position: "absolute",
                                  top: 5,
                                  right: 5,
                                  background: "rgba(255,255,255,0.8)",
                                  borderRadius: "50%",
                                  width: 24,
                                  height: 24,
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  zIndex: 2
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  handleRemoveFile(index);
                                }}
                              >
                                <ClearIcon style={{ fontSize: 16, color: "red" }} />
                              </div>
                            </div>
                          ))}
                          <label htmlFor="file-upload" style={{ margin: 0 }}>
                            <div 
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                height: 150,
                                width: 150,
                                border: "2px dashed #93989F",
                                borderRadius: 8,
                                cursor: "pointer",
                                backgroundColor: "#F9FAFB"
                              }}
                            >
                              <AddIcon sx={{ fontSize: 30, color: "#93989F" }} />
                              <p style={{ color: "#93989F", fontSize: 12, margin: 0 }}>ເພີ່ມຮູບ</p>
                            </div>
                          </label>
                        </div>
                      </div>
                    )}
                  </div>
                  {files.length > 1 && (
                    <p style={{ marginTop: 10, fontSize: 12, color: "#6B7280" }}>
                      ໝາຍເຫດ: ຄລິກທີ່ຮູບທີ່ຕ້ອງການເພື່ອເປັນຮູບປົກ
                    </p>
                  )}
                </label>
              </div>
              
              {/* Preview section for after form submission */}
              {history.length > 0 && history[history.length - 1].images && (
                <div style={{ marginTop: 20, width: "100%" }}>
                  <h5>ຮູບສິນຄ້າທີ່ອັບໂຫລດແລ້ວ</h5>
                  <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}>
                    {history[history.length - 1].images.map((img, index) => (
                      <div key={index} style={{ margin: 5 }}>
                        <img 
                          src={img.preview} 
                          alt={`Product image ${index + 1}`} 
                          style={{
                            objectFit: "contain",
                            borderRadius: 8,
                            height: 150,
                            width: 150,
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div style={{ width: "100%", background: COLOR_WHITE, padding: "2em", borderRadius: 4 }}>
              <Row>
                <Col className="col-6">
                  <Form.Label>ຊື່ສິນຄ້າ <span style={{ color: "red" }}>*</span></Form.Label>
                  <Form.Control
                    name="name"
                    placeholder="ປ້ອນ..."
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.name}
                    style={{
                      border:
                        errors.name && touched.name && errors.name
                          ? "solid 1px red"
                          : "",
                    }}
                  />
                  <small style={{ color: "red" }}>{errors.name}</small>
                </Col>
                {!hasVariant ? (
                  <>
                    <Col className="col-3">
                      <Form.Label>ລະຫັດບຣາໂຄດ <span style={{ color: "red" }}>*</span></Form.Label>
                      {isChecked ? (
                        <Form.Control
                          name="barcodeadd"
                          aria-label="Default select example"
                          onChange={handleBarcodeChange}
                          value={barcode}
                          placeholder="ID bar code..."
                          disabled
                        />
                      ) : (
                        <Form.Control
                          name="barcodeadd"
                          aria-label="Default select example"
                          onChange={handleBarcodeChange}
                          value={barcode}
                          placeholder="ເລກ ID barCode..."
                        />
                      )}
                    </Col>
                    <Col className="col-3">
                      <Form.Label>
                        {" "}
                        <Form.Check
                          aria-label="option 1"
                          value={isChecked}
                          checked={isChecked}
                          onChange={handleCheckboxChange}
                          label={`ໂອໂຕ ບາໂຄ໌ດ`}
                        />{" "}
                      </Form.Label>
                      <Form.Control
                        name="barcode"
                        aria-label="Default select example"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={genBarCode}
                        placeholder="ເລກ ID ສິ້ນຄ້າ..."
                        disabled
                      />
                    </Col>
                  </>
                ) : (
                  <Col className="col-6">
                    <Form.Label>ລະຫັດບາໂຄ໌ດ</Form.Label>
                    <Form.Control
                      name="barcodeadd"
                      aria-label="Default select example"
                      onChange={handleBarcodeChange}
                      value={barcode}
                      placeholder="ປ້ອນລະຫັດບາໂຄ໌ດ..."
                    />
                  </Col>
                )}
              </Row>
              <br />

              <Row className="mt-2">
                <Col className="col-12">
                  <Form.Check
                    type="switch"
                    id="create-variant-product-switch"
                    aria-label="create variant product"
                    checked={hasVariant}
                    onChange={handleVariantChange}
                    label="ສ້າງສິນຄ້າທີ່ມີຫຼາຍຕົວເລືອກ (Variant Product)"
                  />
                </Col>
              </Row>
              <br />

              <Row className="mt-2">
                  <Col className="col-12">
                    <Form.Check
                      type="switch"
                      id="is-using-sale-page-switch"
                      name="isUsingSalePage"
                      label="ໃຊ້ງານໜ້າ Sale Page"
                      checked={values.isUsingSalePage}
                      onChange={handleChange}
                    />
                  </Col>
                </Row>
              <br />

              {/* SKU, CF, Category, Brand Row */}
              <Row className="mt-2">
                {/* {!hasVariant ? (
                  <Col className="col-3">
                    <Form.Label>
                      {" "}
                      <Form.Check
                        aria-label="option 0"
                        value={isCheckSku}
                        checked={isCheckSku}
                        onChange={handleCheckboxChangeSku}
                        label="ໂອໂຕSKU"
                      />{" "}
                    </Form.Label>
                    <Form.Control
                      name="sku"
                      onChange={(e) => {
                        if (!isCheckSku) {
                          handleChange(e);
                        }
                      }}
                      onBlur={handleBlur}
                      value={isCheckSku ? sku : values?.sku}
                      placeholder="ປ້ອນ...."
                      disabled={isCheckSku}
                    />
                    <small style={{ color: "red" }}>{errors.sku}</small>
                  </Col>
                ) : (
                  <Col className="col-3">
                    <Form.Label>SKU</Form.Label>
                    <Form.Control
                      name="sku"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values?.sku}
                      placeholder="ປ້ອນລະຫັດ SKU..."
                    />
                  </Col>
                )} */}
                <Col className="col-3">
                  <Form.Label>ລະຫັດ CF</Form.Label>
                  <Form.Control
                    name="cfMessage"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values?.cfMessage}
                    placeholder="ປ້ອນ...."
                  />
                </Col>
                <Col className="col-3">
                  <Form.Label>ປະເພດ <span style={{ color: "red" }}>*</span></Form.Label>
                  <Form.Select
                    name="category"
                    onChange={(e) => {
                      setSearchCategory(e.target.value);
                    }}
                    value={searchCategory}
                  >
                    <option value="">--ເລືອກ--</option>
                    {category?.map((categorys, index) => (
                      <option key={categorys + index} value={categorys?.id}>
                        {categorys?.name}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
                {!hasVariant && (
                  <Col className="col-3">
                    <Form.Label>ແບຣນ</Form.Label>
                    <Form.Select
                      name="brand"
                      onChange={(e) => {
                        setSearchBrand(e.target.value);
                      }}
                      value={searchBrand}
                    >
                      <option value="">--ເລືອກ--</option>
                      {brand?.map((brands, index) => (
                        <option key={brands + index} value={brands?.id}>
                          {brands?.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                )}
              </Row>
              <br />

              {/* ===== && ===== */}
              {!hasVariant && (
              <Row className="mt-2">
                {/* <Col className="col-3">
                  <Form.Label>ຊັບແບນ</Form.Label>
                  <Form.Select
                    name="brand"
                    aria-label="Default select example"
                    onChange={(e) => {
                      setSearchSubbrand(e.target.value);
                    }}
                    value={searchSubbrand}>
                    <option value="">--ເລືອກ--</option>
                    {subBrand?.map((sub, index) => (
                      <option key={sub + index} value={sub?.id}>
                        {sub?.name}
                      </option>
                    ))}
                  </Form.Select>
                </Col> */}
                <Col className="col-3">
                  <Form.Label>ຫົວໜ່ວຍ</Form.Label>
                  <Form.Select
                    name="unitId"
                    aria-label="Default select example"
                    onChange={(e) => setSelectedUnit(e.target.value)}
                    onBlur={handleBlur}
                    value={selecteUnit}
                  >
                    <option value="">--ເລືອກ--</option>
                    {unit?.map((units, keyunit) => (
                      <option key={keyunit} value={units?.id}>
                        {units?.name}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
                <Col className="col-3">
                  <Form.Label>ຈຳນວນ <span style={{ color: "red" }}>*</span></Form.Label>
                  <NumericFormat
                    name="amount"
                    min={0}
                    className="form-control"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="....."
                    value={values.amount}
                    thousandSeparator={true}
                    prefix={""}

                  />
                  <small style={{ color: "red" }}>{errors.amount}</small>
                </Col>
                {/* {props?.setting?.stockInOut && (
                  <Col className="col-3">
                    <Form.Label>ຄ່າຈັດສົ່ງ</Form.Label>
                    <NumericFormat
                      name="shippingCost"
                      min={0}
                      className="form-control"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="ຄ່າຈັດສົ່ງ....."
                      value={values.shippingCost}
                      thousandSeparator={true}
                      prefix={""}

                    />
                    <small style={{ color: "red" }}>{errors.shippingCost}</small>
                  </Col>
                )} */}
              </Row>
              )}

              {/* ===== && ===== */}

              {!hasVariant && (
              <Row className="mt-2">
                <Col className="col-3">
                  <Form.Label>ລາຄາຕົ້ນທືນ</Form.Label>
                  <NumericFormat
                    name="originPrice"
                    min={0}
                    className="form-control"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="ລາຄາຊື້ສິນຄ້າ..."
                    value={values.originPrice}
                    thousandSeparator={true}
                    prefix={""}
                  />
                </Col>
                <Col className="col-3">
                  <Form.Label>ລາຄາໂປຣໂມຊັ່ນ</Form.Label>
                  <div className="d-flex align-items-center gap-2">
                    <NumericFormat
                      name="promoPrice"
                      min={0}
                      className="form-control"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="ລາຄາໂປຣໂມຊັ່ນ..."
                      value={values.promoPrice}
                      thousandSeparator={true}
                      prefix={""}
                    />
                    <Form.Check 
                      type="switch"
                      id="isPromo-mgmt-switch"
                      name="isPromo"
                      checked={values.isPromo}
                      onChange={handleChange}
                      title="ເປີດໃຊ້ລາຄາໂປຣໂມຊັ່ນ"
                    />
                  </div>
                </Col>
                <Col className="col-2">
                  <Form.Label>ສະກຸນເງີນ <span style={{ color: "red" }}>*</span></Form.Label>
                  <Form.Select
                    name="currency"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.currency}
                    style={{
                      border:
                        errors.currency &&
                          touched.currency &&
                          errors.currency
                          ? "solid 1px red"
                          : "",
                    }}>
                    <option value="">--ເລືອກ--</option>
                    <option value="LAK">ກີບ</option>
                    <option value="BAHT">ບາດ</option>
                    <option value="USD">ໂດລາ</option>
                  </Form.Select>
                  <span style={{ color: "red" }}>{errors.currency}</span>
                </Col>
                <Col className="col-4">
                  <Form.Label>ລາຄາສະແດງຜົນ (String)</Form.Label>
                  <Form.Control
                    name="priceDisplay"
                    placeholder="ຕົວຢ່າງ: ລາຄາເລີ່ມຕົ້ນ 100k..."
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.priceDisplay}
                  />
                </Col>
              </Row>
              )}

              {!hasVariant && (
              <Row className="mt-2">
                <Col className="col-4">
                  <Form.Group controlId="exampleForm.ControlInput0">
                    <Form.Label>ວັນທີນຳເຂົ້າ</Form.Label>
                    <Form.Control
                      type="date"
                      name="importDate"
                      values={values.importDate}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Form.Group>
                </Col>
                <Col className="col-4">
                  <Form.Group controlId="exampleForm.ControlInput1">
                    <Form.Label>ວັນທີຜະລິດ</Form.Label>
                    <Form.Control
                      type="date"
                      name="exp"
                      values={values.exp}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Form.Group>
                </Col>
                <Col className="col-4">
                  <Form.Group controlId="exampleForm.ControlInput1">
                    <Form.Label>ວັນທີ່ໝົດອາຍຸ</Form.Label>
                    <Form.Control
                      type="date"
                      name="mfg"
                      values={values.mfg}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Form.Group>
                </Col>
              </Row>
              )}
              <br />

              {!hasVariant && (
              <Row className="mt-4">
                <Col>
                  <Form.Label>ຂະໜາດ</Form.Label>
                  <Form.Control
                    name="size"
                    placeholder="ຂະຫນາດສີນຄ້າ..."
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.size}
                  />
                </Col>
                {/* Dimension */}
                <Col> {/* Length */}
                  <Form.Label>ລວງຍາວ(cm)</Form.Label>
                  <Form.Control
                    type="number"
                    step="0.01"
                    name="length"
                    value={formDimension.length}
                    onChange={handleChangeDimension}
                    placeholder="ສູງສຸດ 4 ຕົວເລກ..."
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.length}
                  </Form.Control.Feedback>
                </Col>
                <Col> {/* Width */}
                  <Form.Label>ລວງກ້ວາງ(cm)</Form.Label>
                  <Form.Control
                    type="number"
                    step="0.01"
                    name="width"
                    value={formDimension.width}
                    onChange={handleChangeDimension}
                    placeholder="ສູງສຸດ 4 ຕົວເລກ..."
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.width}
                  </Form.Control.Feedback>
                </Col>
                <Col> {/* Height */}
                  <Form.Label>ລວງສູງ(cm)</Form.Label>
                  <Form.Control
                    type="number"
                    step="0.01"
                    name="height"
                    value={formDimension.height}
                    onChange={handleChangeDimension}
                    placeholder="ສູງສຸດ 4 ຕົວເລກ..."
                    aria-label="Length input"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.height}
                  </Form.Control.Feedback>
                </Col>
                <Col> {/* Weight */}
                  <Form.Label>ນ້ຳຫນັກ(kg)</Form.Label>
                  <Form.Control
                    type="number"
                    step="0.01"
                    name="weight"
                    value={formDimension.weight}
                    onChange={handleChangeDimension}
                    placeholder="ສູງສຸດ 4 ຕົວເລກ..."
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.weight}
                  </Form.Control.Feedback>
                </Col>
              </Row>
              )}

              {!hasVariant && (
              <Row className="mt-2">
                {priceOptions.map((price, i) => {
                  return (
                    <>
                      <Form.Group>
                        <Row>
                          <Col>
                            <Form.Label>
                              ລາຄາຂາຍ <span style={{ color: "red" }}>*</span>
                              {i === 0
                                ? ""
                                : i === 1
                                  ? "2"
                                  : i === 2
                                    ? "3"
                                    : ""}
                            </Form.Label>
                            <InputGroup className="">
                              <NumericFormat
                                className="form-control"
                                min={1}
                                name="priceOptionsprice"
                                value={price.price}
                                thousandSeparator={true}
                                onChange={(e) => {
                                  if (
                                    parseFloat(price.price) >=
                                    999999999999999
                                  )
                                    return;
                                  handlePriceChange(e.target.value, i);
                                }}
                                // isInvalid={errors?.priceOptions}
                                style={{
                                  border:
                                    errors.priceOptions &&
                                      touched.priceOptions &&
                                      errors.priceOptions
                                      ? "solid 1px red"
                                      : "",
                                }}
                                placeholder="ລາຄາຂາຍສິ້ນຄ້າ..."
                              />
                            </InputGroup>
                            <small style={{ color: "red" }}>
                              {errors.priceOptions}
                            </small>
                          </Col>
                          <Col>
                            {i >= 1 ? (
                              <>
                                <Form.Label>
                                  ລະບຸຈຳນວນສິນຄ້າຂອງລາຄາ{" "}
                                  <span style={{ color: "red" }}>*</span>
                                  {i === 0
                                    ? ""
                                    : i === 1
                                      ? "2"
                                      : i === 2
                                        ? "3"
                                        : ""}
                                </Form.Label>
                                <InputGroup className="mb-3">
                                  <Form.Control
                                    name="priceOptionsContain"
                                    placeholder="ປ້ອນ..."
                                    onBlur={handleBlur}
                                    value={price.contain}
                                    onChange={(e) => {
                                      handleContainChange(
                                        e.target.value,
                                        i
                                      );
                                    }}
                                  />
                                  {i === 0 ? (
                                    ""
                                  ) : (
                                    <InputGroup.Text
                                      style={{ cursor: "pointer" }}
                                      onClick={() => handleDeletePriceOption(i)}>
                                      <ClearIcon />
                                    </InputGroup.Text>
                                  )}
                                </InputGroup>
                              </>
                            ) : (
                              ""
                            )}
                          </Col>
                          <Col>
                            {i >= 1 ? (
                              <>
                                <Form.Label>
                                  ຫົວໜວ່ຍຂອງລາຄາ{" "}
                                  {i === 0
                                    ? ""
                                    : i === 1
                                      ? "2"
                                      : i === 2
                                        ? "3"
                                        : ""}
                                </Form.Label>
                                <InputGroup className="mb-3">

                                  <Form.Select
                                    name="priceOptionsUnit"
                                    aria-label="Default select example"
                                    placeholder="ຫົວໝວ່ຍ..."
                                    onBlur={handleBlur}
                                    value={price.unit}
                                    onChange={(e) => {
                                      handleUnitChange(e.target.value, i);
                                    }}>
                                    <option value="">--ເລືອກ--</option>
                                    {unit?.map((units, keyunit) => (
                                      <option
                                        key={keyunit}
                                        value={units?.name}>
                                        {units?.name}
                                      </option>
                                    ))}
                                  </Form.Select>
                                  {i === 0 ? (
                                    ""
                                  ) : (
                                    <InputGroup.Text
                                      style={{ cursor: "pointer" }}
                                      onClick={() => handleDeletePriceOption(i)}>
                                      <ClearIcon />
                                    </InputGroup.Text>
                                  )}
                                </InputGroup>
                              </>
                            ) : (
                              ""
                            )}
                          </Col>
                        </Row>
                      </Form.Group>
                    </>
                  );
                })}
                <Col sm={8}></Col>
                {priceOptions?.length >= 3 ? (
                  ""
                ) : (
                  <Col sm={4} >
                    <div className="mt-2 d-flex justify-content-end align-items-end w-100">
                      <Button onClick={() => handleAddMorePrice()} variant="outline-secondary" >
                        <AddIcon />
                        ເພີ່ມລາຄາຂາຍ
                      </Button>
                    </div>
                    {/* <CustomButton
                      title=""
                      margin={0}
                      icon={<AddIcon />}
                      background="#F5F3FF"
                      color="#3C169B"
                      height="40px"
                      borderRadius="8px"
                      
                      width={200}
                    /> */}
                  </Col>
                )}
              </Row>
              )}
              {/* ===== && ===== */}

              <Row className="mt-3">
                {/* {!hasVariant && (
                  <Col>
                    <Form.Label>ເລກຈັດລຽງສະແດງລຳດັບ</Form.Label>
                    <NumericFormat
                      name="containOptionThird"
                      min={0}
                      className="form-control"
                      onChange={(e) => setSortNumber(e.target.value)}
                      placeholder="ເລກຈັດລຽງ..."
                      value={sortNumber}
                      thousandSeparator={true}
                      prefix={""}
                    />
                  </Col>
                )} */}
                <Col>
                  <Form.Label>ໝາຍເລກລອດ</Form.Label>
                  <Form.Select onChange={(e) => setSelectSurvivalNumber(e?.target?.value)} value={selectSurvivalNumber} aria-label="Default select example">
                    <option value="">--ເລືອກ--</option>
                    {survivalDatas.map((option, indexOption) => (
                      <option key={indexOption} value={option?.id}>{option?.survivalNumber}</option>
                    ))}
                  </Form.Select>
                </Col>
              </Row>

              <Row className="mt-3">
                <Col>
                    <Form.Label  style={{fontSize: "12px"}}><span style={{color: "red"}}>*</span> ຂໍ້ມູນສຳລັບສະແດງເທິງ Salepage</Form.Label>
                    <div className="d-flex justify-content-between align-items-center">
                    <Form.Label className="mb-0">ຄຸນລັກສະນະ</Form.Label>
                    <Button
                      variant="outline-secondary"
                      onClick={() =>
                        setFieldValue("specifications", [
                          ...(values.specifications || []),
                          { key: specificationKeys[0]?.key, value: "" },
                        ])
                      }
                    >
                      <AddIcon />
                    </Button>
                  </div>
                  {(values.specifications || []).map((spec, index) => (
                    <Row key={`spec-${index}`} className="mt-2">
                      <Col>
                        <Form.Select
                          value={spec.key || specificationKeys[0]?.key}
                          onChange={(e) => {
                            const next = [...(values.specifications || [])];
                            next[index] = { ...next[index], key: e.target.value };
                            setFieldValue("specifications", next);
                          }}
                        >
                          {specificationKeys.map((keyOption) => (
                            <option key={keyOption.key} value={keyOption.key}>
                              {keyOption.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                      <Col>
                        <Form.Control
                          placeholder="ຄ່າ"
                          value={spec.value}
                          onChange={(e) => {
                            const next = [...(values.specifications || [])];
                            next[index] = { ...next[index], value: e.target.value };
                            setFieldValue("specifications", next);
                          }}
                        />
                      </Col>
                      <Col xs="auto">
                        <Button
                          variant="outline-danger"
                          onClick={() => {
                            const next = (values.specifications || []).filter(
                              (_, i) => i !== index,
                            );
                            setFieldValue(
                              "specifications",
                              next.length > 0
                                ? next
                                : [{ key: specificationKeys[0]?.key, value: "" }],
                            );
                          }}
                        >
                          <ClearIcon />
                        </Button>
                      </Col>
                    </Row>
                  ))}
                </Col>
              </Row>

              {/* <Row>
                <Col>
                  <Form.Group className="mb-3 mt-3">
                    <Form.Control
                      name="shortDescription"
                      placeholder="ຄຳອະທິບາຍສັ້ນ..."
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.shortDescription}
                    />
                  </Form.Group>
                </Col>
              </Row> */}
              <Row>
                <Col>
                  <Form.Group className="mb-3 mt-3">
                    <Form.Control
                      name="description"
                      as="textarea"
                      placeholder="ຄຳອະທິບາຍ..."
                      rows={3}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.description}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <div style={{ display: "flex", justifyContent: "end", gap: 5 }}>
                <Button variant="outline-secondary" className="px-4" disabled={createManagementProductLoading}> <ReactIcons.MdCancel /> ຍົກເລີກ</Button>
                <Button variant="light" onClick={() => handleSubmit()} className="px-4" style={{ background: LINEAR_GRADIENT_BG, color: COLOR_WHITE, border: 'none' }}
                 disabled={createManagementProductLoading}> <ReactIcons.FaCheckCircle /> 
                  {createManagementProductLoading ? "ກະລຸນາລໍຖ້າ..." : "ບັນທືກ"}
                </Button>
              </div>
            </div>
          </div>
        )}
      </Formik>
    </>
  );
}

export default AddOneProductManagement;
